import { Component, ChangeDetectionStrategy, ElementRef, Inject, Input, ChangeDetectorRef, ViewEncapsulation, AfterViewChecked, EventEmitter, Output, OnDestroy } from '@angular/core';
import { TextUtils } from '../../../../resources/text.utils';
import { Subscription, interval } from 'rxjs';
import { startWith, take } from 'rxjs/operators';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'tr-share-course',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./tr-share-course.component.scss'],
    templateUrl: './tr-share-course.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class TrShareCourseComponent implements AfterViewChecked, OnDestroy {

    @Input() public link: string;
    @Output() public onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

    public visible: boolean;
    public linkCopied: boolean;
    public animateLinkOption: boolean;
    public animationStage: number = 0;
    public ready: boolean;
    private animationSubscription: Subscription;

    public get facebookShareLink(): string {
        return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.link)}`;
    }

    public get twitterShareLink(): string {
        return `https://twitter.com/home?status=${encodeURIComponent(this.link)}`;
    }

    constructor(
        public elementReference: ElementRef,
        private changeDetector: ChangeDetectorRef,
        private textUtils: TextUtils,
    ) {}

    public shareOnFacebook(event: Event) {
        event.preventDefault();
        window.open(this.facebookShareLink);
    }

    public shareOnTwitter(event: Event) {
        event.preventDefault();
        window.open(this.twitterShareLink);
    }

    public share(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.textUtils.copyToClipboard(this.link);
        this.runCopyAnimation();
    }

    public show() {
        this.visible = true;
        this.changeDetector.detectChanges();
    }

    public hide() {
        if (this.animationSubscription) this.animationSubscription.unsubscribe();

        this.animationStage = 0;
        this.visible = false;
        this.changeDetector.detectChanges();
        this.onClose.emit(true);
    }

    public runCopyAnimation() {
       this.animationStage = 1;
       this.changeDetector.detectChanges();

       this.animationSubscription =  interval(200)
           .pipe(
               startWith(0),
               take(16),
            )
            .subscribe((time) => {
            const timeNormalized = time * 200;
            switch (timeNormalized) {
                case 200:
                    this.animationStage = 2;
                    break;
                case 600:
                    this.animationStage = 3;
                    break;
                case 2800:
                    this.hide();
                    break;
            }
            this.changeDetector.detectChanges();
        });
    }

    public ngAfterViewChecked() {
        this.ready = true;
    }

    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    // tslint:disable-next-line: no-empty
    public ngOnDestroy() { }
}
